import { TableSkeleton } from "./TableSkeleton";
export default TableSkeleton;